// src/utils/roleUtils.js

const roleMap = {
    1: '普通用户',
    2: '门店用户',
    3: '供应商',
    4: '管理员'
};

// 反转映射：中文 -> 英文键
const reverseRoleMap = Object.entries(roleMap).reduce((acc, [key, value]) => {
    acc[value] = key;
    return acc;
}, {});


/**
 * 将角色键转换为中文名称
 * @param {string} role - 角色英文键
 * @returns {string}
 */
export const getRoleLabel = (role) => {
    return roleMap[role] || role;
};

/**
 * 根据中文名称获取角色键（英文）
 * @param {string} label - 中文角色名，如 "管理员"
 * @returns {string|undefined} - 返回对应的英文键，如 "admin"，无匹配则返回 undefined 或默认值
 */
export const getRoleKeyFromLabel = (label) => {
    return reverseRoleMap[label];
};

/**
 * 返回整个映射表，用于 Select 等组件渲染选项
 * @returns {Array<{value: string, label: string}>}
 */
export const getRoleOptions = () => {
    return Object.entries(roleMap).map(([value, label]) => ({
        value,
        label,
    }));
};

export default {
    getRoleLabel,
    getRoleKeyFromLabel,
    getRoleOptions,
};



